<template>
  <div class="wizard-container">
    <!-- <div v-for="conflict in conflicts">
    <ChannelConflictButtons
      :conflict="conflict"
      :type="type" />
  </div> -->
    <v-select
      :items="conflictResult.templates"
      @update:model-value="selectedItemType = 'templates'"
      item-title="current.name"
      v-model="selectedItem"
      return-object
      label="Issues to Resolve"></v-select>
    <!--
    <div class="tracker">
      <div v-if="conflictResult.templates">
        <h3>Templates:</h3>
        <div class="tracker-items-container">
          <div
            v-for="(template, index) in conflictResult.templates"
            class="tracker-item"
            :class="{ 'tracker-item-selected': selectedItem === template }">
            <div @click="setItem(index, 'templates')">
              <ResolvedIcon :item="template" />
              {{ template.current.name }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="conflictResult.assets">
        <h3>Assets:</h3>
        <div class="tracker-items-container">
          <div
            v-for="(asset, index) in conflictResult.assets"
            class="tracker-item"
            :class="{ 'tracker-item-selected': selectedItem === asset }">
            <div @click="setItem(index, 'assets')">
              <ResolvedIcon :item="asset" />
              {{ asset.current.name }}
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="selected-item">
      <ChannelConflictButtons
        v-if="selectedItem && selectedItemType"
        :conflict="selectedItem"
        :type="selectedItemType" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { type Ref, ref } from 'vue';
import ChannelConflictButtons from './ChannelConflictButtons.vue';
import ResolvedIcon from './ResolvedIcon.vue';

import type {
  ConflictResult,
  AssetConflictInfo,
  TemplateConflictInfo,
} from './conflictResultDefinition';

const props = defineProps<{
  conflictResult: ConflictResult;
}>();

const conflicts = ref(props.conflictResult);

const selectedItem: Ref<null | TemplateConflictInfo | AssetConflictInfo> =
  ref(null);

const selectedItemType = ref<'templates' | 'assets' | null>(null);

function setItem(index: number, type: 'templates' | 'assets') {
  console.log('setItem', index, type);

  const arrayToIndex =
    type === 'templates' ? conflicts.value.templates : conflicts.value.assets;

  if (arrayToIndex && !!arrayToIndex[index]) {
    selectedItem.value = arrayToIndex[index];
    selectedItemType.value = type;
    return;
  }

  selectedItem.value = null;
  selectedItemType.value = 'templates';
  console.log('out');
}
</script>

<style scoped>
.tracker {
  width: 300px;
  height: 100%;
  outline: 1px solid gold;
}
.tracker-items-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
}
.tracker-item {
  outline: 1px solid red;
  border-radius: 5px;
  padding: 5px;
}

.tracker-item-selected {
  background-color: greenyellow;
}

.wizard-container {
  display: flex;
  flex-direction: column;
  /* height: 90vh; */
}
</style>
